.action {
	width: 240px;
}
